
  export default {
    props: { bundle: { type: Object, required: true } },
    computed: {
      speedType () {
        return this.bundle.bb_average_download ? 'average' : 'upto';
      },
      tooltip () {
        let opts = { content: this.$t(`summary.speed.tooltip.${this.speedType}`) };
        if (!this.$store.getters['utils/isTablet']) {
          opts.trigger = 'click';
        }
        return opts;
      }
    }
  };
